import classNames from 'classnames'
import styles from './EmailEditor.module.scss'
import { type Badge, type BadgeVariant } from './emailTemplateTypes'
import { $getEmailNode } from './nodes/EmailNode'
import { CHIP_CLASSES } from './nodes/VariableNode'

const VARIANT_CLASSES: Record<BadgeVariant, string> = {
  secondary: 'zocks-bg-color-gray-200 zocks-text-gray-600',
}

const BADGES_ATTRIBUTE = 'data-email-badges'

export const BADGE_CHIP_CLASSES = classNames(CHIP_CLASSES)

export const BADGES_CLASSES = classNames(styles.badges, 'd-flex flex-wrap gap-1')

export const badgeClasses = (badge: Badge): string => classNames(styles.badge, 'rounded-pill px-2 paragraph-small', VARIANT_CLASSES[badge.variant])

export type BadgePart = { kind: 'text'; text: string } | { kind: 'chip'; label: string }

export const badgeParts = (badge: Badge, labels: Map<string, string>): BadgePart[] =>
  badge.children.map((child) =>
    child.type === 'text' ? { kind: 'text', text: child.text } : { kind: 'chip', label: labels.get(child.variable) ?? child.variable },
  )

export const $variableLabels = (): Map<string, string> => new Map(($getEmailNode()?.getVariables() ?? []).map((variable) => [variable.name, variable.label]))

const createBadgeElement = (badge: Badge, labels: Map<string, string>): HTMLElement => {
  const element = document.createElement('span')
  element.className = badgeClasses(badge)
  element.dataset.emailBadge = badge.variant
  element.append(
    ...badgeParts(badge, labels).map((part) => {
      if (part.kind === 'text') {
        return document.createTextNode(part.text)
      }
      const chip = document.createElement('span')
      chip.className = BADGE_CHIP_CLASSES
      chip.textContent = part.label
      return chip
    }),
  )
  return element
}

export const createBadgesElement = (badges: Badge[], labels: Map<string, string>): HTMLElement => {
  const element = document.createElement('span')
  element.className = BADGES_CLASSES
  element.contentEditable = 'false'
  element.setAttribute(BADGES_ATTRIBUTE, '')
  element.append(...badges.map((badge) => createBadgeElement(badge, labels)))
  return element
}

export const badgesElementIn = (element: HTMLElement): HTMLElement | null => element.querySelector(`:scope > [${BADGES_ATTRIBUTE}]`)
